import React, { useContext } from 'react';

import RightsRow from './RightsRow';
import { EntityContext } from '../../context';

const RightsBlock = () => {
  const isEditMode = useContext(EntityContext);

  return (
    <>
      <RightsRow
        isEditMode={isEditMode}
        leftLabel="Create Right"
        rightLabel="View Right"
        leftFieldKey="UserCreate"
        rightFieldKey="UserView"
      />
      <RightsRow
        isEditMode={isEditMode}
        leftLabel="Edit Right"
        rightLabel="Delete Right"
        leftFieldKey="UserEdit"
        rightFieldKey="UserDelete"
      />
      <RightsRow
        isEditMode={isEditMode}
        leftLabel="Supervisor Right"
        rightLabel="Void Right"
        leftFieldKey="UserSupervisor"
        rightFieldKey="UserVoid"
      />
    </>
  );
};

export default RightsBlock;
